module.exports = __webpack_public_path__ + "static/media/icon-y-adult-male.4dd62125.svg";